export const SUBSCRIPTION_PAYMENT_FIELDS = `
  id
  subscriptionId
  amount
  currency
  transactionId
  purchasedAt
  expiredAt
`;
